import styled from "styled-components";
import dayjs from "dayjs";
import PropTypes from "prop-types";

const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 288px;
  padding: 8px 12px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  font-size: 14px;
`;

const Label = styled.div`
  color: #6b7280;
`;

const DateValue = styled.div`
  color: #0C53BB;
  font-weight: 500;
`;

export const CalendarFooter = ({ text = "Start Date", date }) => {
  return (
    <FooterWrapper>
      <Label>{text}</Label>
      <DateValue>{date ? dayjs(date).format("MMM D, YYYY") : "--"}</DateValue>
    </FooterWrapper>
  );
};

CalendarFooter.propTypes = {
  text: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
};
